import DOMPurify from 'dompurify'

/**
 * Sanitize HTML content to prevent XSS attacks.
 * Only allows safe tags and attributes suitable for rich text content.
 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      // Text formatting
      'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's',
      // Headings
      'h2', 'h3',
      // Lists
      'ul', 'ol', 'li',
      // Links
      'a',
      // Block elements
      'blockquote', 'hr',
    ],
    ALLOWED_ATTR: [
      'href', 'target', 'rel', 'class',
    ],
    // Force all links to open in new tab with security attributes
    FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick', 'onmouseover'],
    // Remove any script or event handler content
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input'],
  })
}

/**
 * Check if a string contains HTML tags.
 * Used to determine if content should be rendered as HTML or plain text.
 */
export function isHtmlContent(content: string): boolean {
  return /<[a-z][\s\S]*>/i.test(content)
}
